/**
 * Handle product faq item
 */
const handleMobileProductFaqItem = () => {
	$('.product-faq__item').each(function(index, el) {
		const $this = $(this);
		const $body = $this.find('.product-faq__item-body');
		const isMobileScreen = $(window).innerWidth() <= 1023;
		const isCurrent = $this.hasClass('is-current');

		if (isMobileScreen) {
			if (! isCurrent) {
				$body.slideUp();
			}
		} else {
			$this.removeClass('.is-current');
			$body.removeAttr('style');
		}
	});
}

handleMobileProductFaqItem();

/**
 * Handle product faq item on resize
 */
let resizeTimeout;

$(window).on('resize', function(){
	if (resizeTimeout) clearTimeout(resizeTimeout);

	resizeTimeout = setTimeout(function(){
		handleMobileProductFaqItem();
	}, 100);
});
